module.exports = __webpack_public_path__ + "img/triangle-half.c07f3e22.svg";